export function isProd() {
    return process.env.NODE_ENV === 'production';
}
export function sleep(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
export function canReceiveServiceWorker() {
    return 'serviceWorker' in navigator;
}
export function registerServiceWorker(path) {
    return navigator.serviceWorker.register(path);
}
export function isPresentServiceWorker() {
    return navigator.serviceWorker.controller;
}
export function isReadyServiceWorker() {
    return navigator.serviceWorker.ready;
}
export function getRegistrationsServiceWorker() {
    return navigator.serviceWorker.getRegistrations();
}
export function onServiceWorkerChanged(cb) {
    navigator.serviceWorker.addEventListener('controllerchange', cb);
}
